import { Star } from "lucide-react";

const RatingStar = ({ filled, onClick, onMouseEnter, onMouseLeave }) => {
  return (
    <Star
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className={`w-8 h-8 cursor-pointer transition
        ${filled ? "fill-yellow-400 text-yellow-400" : "text-gray-300"}
        hover:scale-110`}
    />
  );
};

export default RatingStar;
